module.exports = __webpack_public_path__ + "img/book14.24d3e942.jpg";